import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import Moment from "moment";
import { getRootUrl } from "helpers/url";
import { isUserStudent } from "helpers/user";
import { getBlocksByReference } from 'actions/blocks';
import { getAssignmentAssessment } from "actions/assessments";
import { getTaskDetails, getAssignmentSection } from "actions/assignments";
import UserAssignment from "components/List/UserAssignment";
import PostContent from "components/Presentation/PostContent";
import Status from "components/Presentation/Status";
import UserGroupAssignment from "components/List/UserGroupAssignment";
import AssessmentsConsumer from 'components/BlockAssessments/Consumer';
import { Icon, Button, getActiveLanguage, translate } from '@haldor/ui';
import { List, Spinner } from "UI";

var PrintAssignment = /*#__PURE__*/function (_Component) {
  _inherits(PrintAssignment, _Component);

  var _super = _createSuper(PrintAssignment);

  function PrintAssignment(props) {
    var _this;

    _classCallCheck(this, PrintAssignment);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "goBack", function (event) {
      event.preventDefault();
      window.history.go(-1);
      setTimeout(function () {
        if (this != null && this.props != null) {
          var match = this.props.match;
          window.location.href = "".concat(getRootUrl(), "assignment/").concat(match.params.assignmentId);
        }
      }, 200);
      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "backButton", function () {
      var match = _this.props.match;

      if (match.params.assignmentId) {
        return /*#__PURE__*/React.createElement(Link, {
          onClick: _this.goBack,
          style: {
            cursor: "pointer",
            color: "black",
            textDecoration: "none"
          },
          className: "teams-icon-go-back",
          to: "#"
        }, /*#__PURE__*/React.createElement("span", {
          className: "chevron",
          style: {
            paddingLeft: "0.5em"
          }
        }, _this.props.translate("back")));
      } else {
        return null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "pupilStatusIndicator", function (status) {
      if (status === "ASSIGNMENT_TASK_NOT_STARTED") {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-gray"
        }, _this.props.translate("not-started"));
      } else if (status === "ASSIGNMENT_TASK_STARTED") {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-gray"
        }, _this.props.translate("started"));
      } else if (status === "ASSIGNMENT_TASK_SUBMITTED" || status === "ASSESSMENT_COMPLETED" || status === "ASSESSMENT_STARTED") {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-yellow"
        }, _this.props.translate("submitted"));
      } else if (status === "ASSIGNMENT_TASK_NOT_COMPLETE") {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-red"
        }, _this.props.translate("not-complete"));
      } else if (status === "ASSIGNMENT_TASK_CAN_DEVELOP") {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-orange"
        }, _this.props.translate("can-develop"));
      } else if (status === "ASSESSMENT_PUBLISHED") {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-green"
        }, _this.props.translate("assessed"));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "assignmentIndicator", function (status) {
      if (status === "ASSIGNMENT_OPEN") {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-green"
        }, _this.props.translate("Open"));
      } else if (status === "ASSIGNMENT_CLOSED") {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-red"
        }, _this.props.translate("Hidden"));
      } else if (status === "ASSIGNMENT_DRAFT") {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-gray"
        }, _this.props.translate("Draft"));
      } else if (status === "ASSIGNMENT_DELETED") {
        return /*#__PURE__*/React.createElement("span", {
          className: "dot dot-red"
        }, _this.props.translate("Deleted"));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "printDialog", function () {
      window.print();
    });

    _defineProperty(_assertThisInitialized(_this), "taskContent", function () {
      Moment.locale(getActiveLanguage());
      var isStudent = isUserStudent(_this.props.currentUser);
      var teacherOwnsAssignment = _this.props.sections.find(function (t) {
        return t.id == _this.props.assignment.sectionId && t.userRole == 'OWNER';
      }) == null ? false : true;
      var assessmentBlocks = [];
      var assessment = null;

      if (_this.props.blocks != null) {
        assessmentBlocks = _toConsumableArray(_this.props.blocks).filter(function (block) {
          return block.type == 'Haldor.Blocks.AssessmentBlock' && block.resources.length > 0;
        });

        if (isStudent && _this.props.assessments.length > 0) {
          assessment = _this.props.assessments[0];
        }
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "single-task",
        key: _this.props.assignment.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-section no-print"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: _this.printDialog
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Printer"
      }), _this.props.translate("print"))), /*#__PURE__*/React.createElement("div", {
        className: "single-section df jcb fw"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginRight: '.65rem'
        }
      }, /*#__PURE__*/React.createElement("h4", {
        style: {
          marginTop: 0
        }
      }, _this.props.translate("Status")), _this.props.assignment.created == "0001-01-01T00:00:00" ? /*#__PURE__*/React.createElement("div", {
        className: "badge-primary"
      }, _this.props.translate("task-is-creating")) : /*#__PURE__*/React.createElement("div", null, isStudent ? _this.pupilStatusIndicator(_this.props.assignment.tasks[0].status) : _this.assignmentIndicator(_this.props.assignment.status))), isStudent ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
        style: {
          marginTop: 0
        }
      }, _this.props.translate("members")), _this.renderMembersForStudent()) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginRight: '.65rem'
        }
      }, /*#__PURE__*/React.createElement("h4", {
        style: {
          marginTop: 0
        }
      }, _this.props.translate("information")), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "inline-block"
        }
      }, /*#__PURE__*/React.createElement(Status, {
        type: "assignmentTypes",
        id: _this.props.assignment.assignmentType
      }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
        style: {
          marginTop: 0
        }
      }, _this.props.translate("start")), /*#__PURE__*/React.createElement("div", null, Moment.utc(_this.props.assignment.startDate).local().format("D MMM H:mm"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
        style: {
          marginTop: 0
        }
      }, _this.props.translate("end")), /*#__PURE__*/React.createElement("div", null, Moment.utc(_this.props.assignment.dueDate).local().format("D MMM H:mm")))), /*#__PURE__*/React.createElement("div", {
        className: "single-section form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-assignment-meta"
      }, /*#__PURE__*/React.createElement("span", null, _this.props.section.title)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
        style: {
          display: "inline-block",
          fontWeight: "600",
          fontSize: "2.2em"
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          color: "#3A3A3A"
        }
      }, _this.props.assignment.title)))), /*#__PURE__*/React.createElement("div", {
        className: "single-section form"
      }, /*#__PURE__*/React.createElement(PostContent, null, _this.props.assignment.description)), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: "both"
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "single-section-divider",
        style: {
          marginBottom: "3rem"
        }
      }), isStudent == false && teacherOwnsAssignment ? _this.props.assignment.groupEnabled ? /*#__PURE__*/React.createElement(List, {
        title: _this.props.translate("students")
      }, /*#__PURE__*/React.createElement(UserGroupAssignment, {
        assignment: _this.props.assignment,
        reload: null,
        printable: true
      })) : /*#__PURE__*/React.createElement(List, {
        title: _this.props.translate("students")
      }, /*#__PURE__*/React.createElement(UserAssignment, {
        assignment: _this.props.assignment,
        reload: null,
        printable: true
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "single-section print-core-contents"
      }, /*#__PURE__*/React.createElement(AssessmentsConsumer, {
        fields: assessmentBlocks,
        assessment: assessment,
        isStudent: isStudent
      })));
    });

    _this.state = {};
    Moment.locale(getActiveLanguage());
    return _this;
  }

  _createClass(PrintAssignment, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var params = this.props.match.params;

      if (params.assignmentId > 0) {
        this.props.getTaskDetails(params.assignmentId).then(function () {
          if (_this2.props.section == null) {
            _this2.props.getAssignmentSection(_this2.props.assignment.sectionId);
          }
        });
        this.props.getBlocksByReference(params.assignmentId, 'ASSIGNMENT');
        this.props.getAssignmentAssessment(params.assignmentId);
      }
    }
  }, {
    key: "renderMembersForStudent",
    value: function renderMembersForStudent() {
      if (this.props.activeTask != null && this.props.activeTask.tasks[0] != null) {
        return this.props.activeTask.tasks[0].assignedUsers.map(function (student) {
          return /*#__PURE__*/React.createElement("div", null, "".concat(student.firstName, " ").concat(student.lastName));
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.assignment != null && this.props.section != null) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: "back-button single-section no-print"
        }, this.backButton()), /*#__PURE__*/React.createElement("div", {
          className: "container"
        }, this.taskContent()));
      } else {
        return /*#__PURE__*/React.createElement("div", {
          className: "container"
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }
    }
  }]);

  return PrintAssignment;
}(Component);

function mapStateToProps(state) {
  return {
    sections: state.sections.educationGroups,
    assignment: state.assignments.active_assignment,
    assignmentTypes: state.status.assignmentTypes,
    blocks: state.Blocks.reference,
    currentUser: state.user.currentUser,
    assessments: state.assessments.assessments,
    section: state.assignments.section,
    translate: translate(state.Languages.translations),
    languages: state.Languages.languages
  };
}

export default connect(mapStateToProps, {
  getTaskDetails: getTaskDetails,
  getAssignmentAssessment: getAssignmentAssessment,
  getAssignmentSection: getAssignmentSection,
  getBlocksByReference: getBlocksByReference
})(PrintAssignment);